<template>
  <section>
    <div class="container col-lg-9 mx-auto pb-5 mb-5">
      <div
        class="rounded-card bg-light shadow py-5 row d-flex align-items-center"
      >
        <div class="px-xxl-5">
          <nav
            class="nav row text-center d-flex justify-content-between col-12 col-md-10 col-lg-8 col-xxl-6 mx-auto"
          >
            <p
              v-for="(filter, i) in filters"
              :key="i"
              class="nav-link cursor-pointer d-inline cursor-pointer filters font-montserrat col-12 col-sm-4"
              :class="filter.name.toLowerCase()"
              tabindex="-1"
              aria-current="page"
              @click="loadPostsOfCategory(filter.id)"
            >
              {{ filter.name }}
            </p>
          </nav>
          <div class="px-md-5">
            <tools-market-research-section :firstArticle="firstArticle" />
          </div>
        </div>
        <div class="ratio ratio-774x262">
          <img src="../../../assets/images/two-eyes.png" alt="two-eyes-image" />
        </div>
        <div class="px-xxl-5">
          <div class="px-md-5">
            <blog-articles-section :articles="articles" />
          </div>
        </div>
        <div
          v-if="nextPage"
          class="text-center fs-5 cursor-pointer mt-4"
          @click="loadMore()"
        >
          <p class="mb-0 font-montserrat">Load more</p>
          <i class="fa fa-caret-down fa-2x opacity-50" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "BackgroundCard",
  components: { BlogArticlesSection, ToolsMarketResearchSection },
};
</script>
<script setup>
import { ref, onMounted } from "vue";
import { blogApi } from "@/main.ts";
import BlogArticlesSection from "@/components/blog/index/background-card/BlogArticlesSection";
import ToolsMarketResearchSection from "@/components/blog/index/background-card/ToolsMarketResearchSection";

const articles = ref([]);
const filters = ref([]);
const firstArticle = ref({});
const nextPage = ref();

onMounted(async () => {
  try {
    let response = await blogApi.get("/blog-posts");
    articles.value = response.data.data;
    nextPage.value = response.data.links.next;
    filters.value = (await blogApi.get("/blog-categories")).data.data;
    firstArticle.value = articles.value.shift();
  } catch (e) {
    console.log(e);
  }
});

const loadPostsOfCategory = async (id) => {
  try {
    let response = await blogApi.get(`/blog-categories/${id}`);
    articles.value = response.data.data;
    nextPage.value = response.data.links.next;
    firstArticle.value = articles.value.shift();
  } catch (e) {
    console.log(e);
  }
};

const loadMore = async () => {
  try {
    let response = await blogApi.get(nextPage.value);
    articles.value = articles.value.concat(response.data.data);
    nextPage.value = response.data.links.next;
  } catch (e) {
    console.log(e);
  }
};
</script>

<style scoped>
.nav-link {
  color: #707070;
}
.product:hover,
.product:focus {
  color: #b63cff;
}
.methodologies:hover,
.methodologies:focus {
  color: #00b9ff;
}
.scenarios:hover,
.scenarios:focus {
  color: #31da00;
}
</style>
